"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BankTile = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const Button = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-width: 128px;\n  width: ", ";\n  height: 88px;\n  background: #ffffff;\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  border: none;\n  border-color: unset;\n  transition: width 0.2s, height 0.2s, background 0.2s, border: 0.2s;\n\n  img {\n    height: 72px;\n    width: 100%;\n    transition: width 0.2s, height 0.2s;\n  }\n\n  &:hover {\n    background: #f8f8f8;\n  }\n\n  &:active {\n    box-shadow: none;\n    border: 1px solid #cccccc;\n    box-sizing: border-box;\n    background: #ffffff;\n  }\n\n  @media (max-height: 740px) {\n    height: 72px;\n    min-width: 128px;\n    img {\n      height: 60px;\n      width: 93px;\n    }\n  }\n"])), props => props.width || "100%");
const BankTile = _ref => {
  let {
    bank,
    ...props
  } = _ref;
  const {
    bankLogo,
    bankName
  } = bank;
  let content = bankName;
  if (bankLogo) {
    content = /*#__PURE__*/_react.default.createElement("img", {
      src: bankLogo,
      alt: bankName
    });
  }
  return /*#__PURE__*/_react.default.createElement(Button, _extends({
    type: "button",
    className: "bankTile"
  }, props), content);
};
exports.BankTile = BankTile;
BankTile.propTypes = {
  bank: _propTypes.default.object,
  onClick: _propTypes.default.func
};
BankTile.defaultProps = {
  bank: "capitalOne",
  onClick: undefined
};